import { useQuery, QueryResult } from '@apollo/client'
import {
  BuCompanySettingsReviewerQuery,
  BuCompanySettingsReviewerQueryVariables,
  CompanySettingsReviewerQuery,
  CompanySettingsReviewerQueryVariables,
} from '../../types'
import { BU_COMPANY_SETTINGS_REVIEWER, COMPANY_SETTINGS_REVIEWER } from './CompanySettingsQueries'

export const useCompanySettingsReviewer = (
  companyId: string,
): QueryResult<CompanySettingsReviewerQuery, CompanySettingsReviewerQueryVariables> => {
  return useQuery<CompanySettingsReviewerQuery, CompanySettingsReviewerQueryVariables>(COMPANY_SETTINGS_REVIEWER, {
    variables: { companyId },
  })
}

export const useBuCompanySettingsReviewerRelations = (
  buId: string,
): QueryResult<BuCompanySettingsReviewerQuery, BuCompanySettingsReviewerQueryVariables> => {
  return useQuery<BuCompanySettingsReviewerQuery, BuCompanySettingsReviewerQueryVariables>(BU_COMPANY_SETTINGS_REVIEWER, {
    variables: { buId },
  })
}
